import type { Theme } from '@mui/material'

const FLASHES = ['odd', 'even'] as const

// Each value has its own animation, so switching between them plays it again. It fades back to the element's own
// background, so it suits a surface and a bare block alike.
export const flashStyles = (theme: Theme) =>
  Object.fromEntries(
    FLASHES.flatMap((flash) => [
      [
        `[data-flash='${flash}']`,
        { '@media (prefers-reduced-motion: no-preference)': { animation: `flash-${flash} 5s ease-out` } },
      ],
      [`@keyframes flash-${flash}`, { from: { backgroundColor: theme.palette.bg.brand.muted } }],
    ])
  )
